import { computed } from 'vue';

import { GenericTitleListsType } from '@/@types/graphql-types';
import {
	GetListsCountDocument,
	GetListsCountQuery,
	GetListsCountQueryVariables,
} from '@/graphql/queries/GetListsCount';
import { useUserStore } from '@/stores/pinia/useUserStore';

export function useListsCount() {
	const userStore = useUserStore();

	const { result: customListsResult, refetch: customListsRefetch } = useQuery<
		GetListsCountQuery,
		GetListsCountQueryVariables
	>(
		GetListsCountDocument,
		{ type: GenericTitleListsType.CustomLists },
		{
			enabled: () => userStore.isLoggedIn,
			fetchPolicy: 'network-only',
		}
	);

	const { result: followedListsResult, refetch: followedListsRefetch } = useQuery<
		GetListsCountQuery,
		GetListsCountQueryVariables
	>(
		GetListsCountDocument,
		{ type: GenericTitleListsType.FollowedLists },
		{
			enabled: () => userStore.isLoggedIn,
			fetchPolicy: 'network-only',
		}
	);

	const customListsCount = computed(() => customListsResult.value?.genericTitleLists.totalCount ?? 0);

	const followedListsCount = computed(() => followedListsResult.value?.genericTitleLists.totalCount ?? 0);

	return {
		customListsCount,
		customListsCountRefetch: customListsRefetch,

		followedListsCount,
		followedListsCountRefetch: followedListsRefetch,
	};
}
